<template>
    <v-layout
        row
        wrap
    >
        <!-- Close -->
        <v-flex
            xs6
            offset-xs6
        >
            <!-- Button -->
            <v-btn
                class="my-0"
                color="success"
                block
                @click.stop="dialog = true"
            >
                <v-icon
                    left
                    size="20"
                >
                    {{ buttonIcon }}
                </v-icon>
                Close
            </v-btn>
            <!-- Dialog -->
            <v-dialog
                v-model="dialog"
                max-width="600"
            >
                <v-card>
                    <v-card-title>
                        <h3 class="headline">
                            Close Product Return
                        </h3>
                    </v-card-title>
                    <v-card-text>
                        <p>Confirm the product is in transit.</p>
                        <v-form
                            ref="form"
                            @submit.prevent="onConfirm"
                        >
                            <v-text-field
                                label="Credit Memo Number"
                                v-model="form.creditMemoNumber"
                                :rules="[rules.required]"
                            />
                            <v-textarea
                                label="Message"
                                v-model="form.message"
                                :rules="[rules.required]"
                            />
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer />
                        <v-btn
                            flat
                            @click="dialog = false"
                            :disabled="isSubmitting"
                        >
                            Cancel
                        </v-btn>
                        <v-btn
                            color="primary"
                            @click="onConfirm"
                            :disabled="isSubmitting"
                            :loading="isSubmitting"
                        >
                            Confirm
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-flex>
    </v-layout>
</template>

<script>
import axios from 'axios'
import { statuses, CLOSED } from '../../../utils/constants/statuses'
import { defaultError422, requestErrorMessage } from '../../../utils/constants/errors'
import SnackBus from '../../../utils/buses/snackBus'
import UserBus from '../../../utils/buses/userBus'

export default {
    props: {
        returnId: {
            type: String,
            required: true
        }
    },
    data () {
        return {
            buttonIcon: statuses[CLOSED].icon,
            dialog: false,
            form: {
                message: null,
                creditMemoNumber: null
            },
            rules: {
                required: value => !!value || 'This field is required'
            },
            isSubmitting: false
        }
    },
    methods: {
        onConfirm () {
            if (!this.$refs.form.validate()) {
                SnackBus.showMessage(defaultError422, 'error')
                return
            }
            this.isSubmitting = true
            const formData = new FormData()
            formData.set('token', UserBus.token)
            formData.set('comment', this.form.message)
            formData.set('creditMemoNumber', this.form.creditMemoNumber)

            axios.post('/api/returns/' + this.returnId + '/customerservice/close', formData)
                .then(res => {
                    // refresh data and close dialog
                    this.$emit('refresh-data', true)
                    this.dialog = false
                    SnackBus.showMessage('Status changed to ' + statuses[CLOSED].text, 'success')
                })
                .catch(err => {
                    console.log('Freight Group In Transit Error', err)
                    SnackBus.showMessage(requestErrorMessage, 'error')
                })
                .finally(() => {
                    this.isSubmitting = false
                })
        }
    }
}
</script>

<style>

</style>
